import { Show } from '@/components/show'
import { FieldLabel, type FieldLabelProps } from './FieldLabel'
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldError
} from '@/components/ui/field'
import { useAdditionalLabelProperties } from '../utils/additionalProperties'

export interface Props extends Omit<FieldLabelProps, 'error'> {
  children: React.ReactNode
  error?: string | undefined
  errorMessage?: string
  helperText?: string
  inputId?: string
  label?: string
  labelComponent?: React.ReactNode
}

export function InputFieldset({
  children,
  error,
  errorMessage,
  helperText,
  inputId,
  label,
  labelComponent,
  ...rest
}: Props) {
  const errorText = errorMessage ?? error

  const additionalLabelProps = useAdditionalLabelProperties({
    label,
    labelComponent,
    ...rest
  })

  return (
    <Field>
      <Show when={!!(label || labelComponent || helperText)}>
        <FieldContent>
          <FieldLabel
            {...rest}
            {...additionalLabelProps}
            label={label}
            labelComponent={labelComponent}
            htmlFor={inputId}
            error={!!errorText}
          />
          {helperText && <FieldDescription>{helperText}</FieldDescription>}
        </FieldContent>
      </Show>
      {children}
      {errorText && <FieldError>{errorText}</FieldError>}
    </Field>
  )
}
